import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { Grid, withStyles } from "@material-ui/core";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import CalendarWeekNumber from "app/components/CalendarYear/CalendarWeekNumber";

const SimpleCalendarDay = ({
  date,
  title = formatDate(date, Format.workSchedule),
  classes,
  onClick,
  dateRanges,
  isSelected,
  displayStart,
  DayComponent,
  onSelectDates,
  displayTitle,
  displayWeekNumber,
  DateRangeEndComponent,
  DateRangeStartComponent,
  ...rest
}) => {
  return (
    <Grid
      item
      container
      onClick={onSelectDates ? onClick : undefined}
      title={displayTitle ? title : ""}
      className={classNames(classes.root, {
        [classes.dateSelected]: isSelected,
      })}
    >
      {displayWeekNumber && <CalendarWeekNumber date={date} />}
      {DateRangeStartComponent && (
        <DateRangeStartComponent date={date} dateRanges={dateRanges} />
      )}
      {DayComponent && (
        <DayComponent date={date} isSelected={isSelected} {...rest} />
      )}
      {DateRangeEndComponent && (
        <DateRangeEndComponent
          date={date}
          dateRanges={dateRanges}
          displayStart={displayStart}
        />
      )}
    </Grid>
  );
};

SimpleCalendarDay.defaultProps = {
  displayTitle: true,
  displayWeekNumber: true,
};

const styles = theme => ({
  root: {
    padding: 1,
    height: "100%",
    cursor: "pointer",
    position: "relative",
    width: ({ width }) => (width ? width : "100%"),
    boxShadow: `inset 0px 0px 1px 1px ${theme.palette.grey[100]}`,
    "&:hover": {
      background: theme.altus.calendar.workdayOffColor.hover,
    },
  },
  dateSelected: {
    background: theme.altus.calendar.selectedColor,
    "&:hover": {
      background: theme.altus.calendar.selectedColor,
    },
  },
});

export default compose(React.memo, withStyles(styles))(SimpleCalendarDay);
